<template>
	<div>
		<div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">集团组织架构管理</div>
		<el-row style="margin-top: 9px;">
			<div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; border: 1px solid #eaebed;">
				<el-row>
					<!-- 左侧组织架构 -->
					<el-col :span="4" style="background-color: #f7f8fa; height: 750px;">
						<Structure ref="Structure" @parentFind="Find" :condition="condition" :form="form"></Structure>
					</el-col>

					<!-- 右侧列表 -->
					<el-col :span="20">

						<el-row style="margin-top: 20px;">
							<el-col :span="1" style="text-align: right;">
								<img src="../../../assets/icon/迈亚集团icon@2x.png" height="22px" />
							</el-col>
							<el-col :span="3">
								<span
									style="font-size: 19px; line-height: 26px; margin-left: 5px; font-weight: bold;">{{form.organize_name}}</span>
							</el-col>
							<el-col :span="2">
								<img src="../../../assets/icon/设置@2x.png" height="22px" @click="EditFrom" />
							</el-col>
						</el-row>

						<el-row style="margin-top: 30px; padding: 0 40px;">
							<el-tabs v-model="activeName" :before-leave="Find">

								<el-tab-pane label="下级部门" name="department">
									<department ref="department" @structureFind="structureFind"></department>
								</el-tab-pane>

								<el-tab-pane label="部门人员" name="staff">
									<staff ref="staff" @structureFind="structureFind">
									</staff>
								</el-tab-pane>
							</el-tabs>
						</el-row>

					</el-col>
				</el-row>
			</div>
		</el-row>

		<!-- 部门编辑表单 -->
		<el-dialog center :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
			<template slot="title"><span style="font-weight: bold;">部门编辑</span></template>
			<el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

				<el-row style="margin-left: 30px;">
					<el-col :span="1">
						<div style="height: 20px; width: 2px; border-left: 2px #006E4B solid;"></div>
					</el-col>
					<el-col :span="4" style="margin-left: -10px;"><span
							style="font-size: 16px; line-height: 20px; font-weight: bold; color: #000000;">部门信息</span>
					</el-col>
				</el-row>
				<hr style="margin-left: 30px;" />

				<el-form-item label="部门名称" prop="organize_name" style="margin-top: 20px;">
					<el-input v-model="form.organize_name" placeholder="请输入部门名称"></el-input>
				</el-form-item>
				<el-form-item label="部门主管" prop="staff_ids">
					<div @click="setStaff">
						<el-input v-model="form.staff_name" placeholder="点击设置部门主管" onfocus="this.blur();"></el-input>
					</div>
				</el-form-item>

				<div v-show="condition.flag != 'group'">
					<el-row style="margin-left: 30px; margin-top: 40px;">
						<el-col :span="1">
							<div style="height: 20px; width: 2px; border-left: 2px #006E4B solid;"></div>
						</el-col>
						<el-col :span="4" style="margin-left: -10px;"><span
								style="font-size: 16px; line-height: 20px; font-weight: bold; color: #000000;">调整架构级别</span>
						</el-col>
					</el-row>
					<hr style="margin-left: 30px;" />

					<el-form-item label="调整架构级别" style="margin-top: 20px;">
					
						<el-select v-model="form.spare5" placeholder="请选择">
							<el-option
							v-for="item in organizeLevel"
							:key="item.value"
							:label="item.label"
							:value="item.value">
							</el-option>
						</el-select>

					</el-form-item>
				</div>

				<div v-show="condition.flag != 'group'">
					<el-row style="margin-left: 30px; margin-top: 40px;">
						<el-col :span="1">
							<div style="height: 20px; width: 2px; border-left: 2px #006E4B solid;"></div>
						</el-col>
						<el-col :span="4" style="margin-left: -10px;"><span
								style="font-size: 16px; line-height: 20px; font-weight: bold; color: #000000;">调整架构</span>
						</el-col>
					</el-row>
					<hr style="margin-left: 30px;" />

					<el-form-item label="调整架构" style="margin-top: 20px;">
						<el-cascader v-model="form.organize_id" style="width: 100%;" :props="props"></el-cascader>
					</el-form-item>

					<el-form-item label="跨区域调整" style="margin-top: 20px;">
						<el-radio v-model="form.radio" label="1">是</el-radio>
						<el-radio v-model="form.radio" label="2">否</el-radio>
					</el-form-item>

					<el-form-item label="实际调整时间" style="margin-top: 20px;">
						<el-date-picker
							v-model="form.years_date"
							type="month"
							placeholder="选择月">
						</el-date-picker>
					</el-form-item>
			
				</div>

				<div v-show="condition.flag != 'group'">
					<el-row style="margin-left: 30px; margin-top: 40px;">
						<el-col :span="1">
							<div style="height: 20px; width: 2px; border-left: 2px #006E4B solid;"></div>
						</el-col>
						<el-col :span="4" style="margin-left: -10px;"><span
								style="font-size: 16px; line-height: 20px; font-weight: bold; color: #000000;">合并部门</span>
						</el-col>
					</el-row>
					<hr style="margin-left: 30px;" />

					<el-form-item label="合并部门" style="margin-top: 20px;">
						<el-cascader v-model="form.merge_id" style="width: 100%;" :props="props"></el-cascader>
					</el-form-item>
				</div>
				<el-form-item label-width="0" style="text-align: center;">
					<el-button type="primary"
						style="background-color: #006E4B; border: 1px #006E4B solid; width: 100px;" @click="Save">保存
					</el-button>
				</el-form-item>
			</el-form>

			<!-- 部门主管弹出层 -->
			<el-dialog width="40%" center :visible.sync="setStaffVisible" append-to-body :close-on-click-modal="false"
				:show-close="true">
				<template slot="title"><span style="font-weight: bold;">设置部门主管</span></template>
				<el-row style="border:1px solid #EBEEF5;">
					<setStaff ref="setStaff" type="checkbox" :accordion="false" @commit="saveChange">
					</setStaff>
				</el-row>
				<el-row style="text-align: center;">
					<el-button type="goon" style="margin-top: 10px;" @click="$refs['setStaff'].commit()">确定</el-button>
				</el-row>
			</el-dialog>

		</el-dialog>
	</div>
</template>

<script>
	import Structure from "../../utils/structure/structures.vue";
	import department from "./Jtzzjggl_department.vue";
	import staff from "./Jtzzjggl_staff.vue";

	import setStaff from "../../utils/organizeStaff/organizeStaff.vue";

	export default {
		components: {
			Structure: Structure,
			department: department,
			staff: staff,
			setStaff: setStaff,
		},
		data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			return {
				//页面相关
				activeName: "department",
				dialogVisible: false,

				setStaffVisible: false,

				//条件
				condition: {
					//部门id
					project_id: "",
					//部门名
					project_name: "",
					//标识
					flag: "group",
				},

				organizeLevel:[{
					value: '1',
					label: '第一级别'
				}, {
					value: '2',
					label: '第二级别'
				}, {
					value: '3',
					label: '第三级别'
				}, {
					value: '4',
					label: '第四级别'
				}, {
					value: '5',
					label: '第五级别'
				}, {
					value: '6',
					label: '第六级别'
				}, {
					value: '7',
					label: '第七级别'
				}],

				//表单数据
				form: {
					id: "",
					organize_name: "",
					staff_ids: [],
					staff_name: "",
					merge_id: [],
					merge_name: "",
					organize_id:[],
					spare5:"",
					radio:"2",
					years_date:"",
				},

				//表单验证
				rules: {
					organize_name: [{
						required: true,
						message: '请输入部门名称！',
						trigger: 'blur'
					}],
				},


				//级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
					value: "id",
					label: "organize_name",
					children: "organizeList",
					checkStrictly:true,
				},
			}
		},
		methods: {
			//部门编辑表单
			EditFrom() {
				this.dialogVisible = true;
			},
			//设置部门主管页面
			setStaff() {
				this.setStaffVisible = true;
			},
			//设置确定
			saveChange(e) {
				this.form.staff_ids = e.staff_ids;
				this.form.staff_name = e.staff_name;
				
				this.setStaffVisible = false;
			},
			//刷新页面
			Find() {
				//查询子部门
				this.$refs["department"].condition = this.condition;
				this.$refs["department"].Find();

				//查询部门人员
				this.$refs["staff"].condition = this.condition;
				this.$refs["staff"].Find();
			},
			//保存
			Save() {
				this.$refs["ruleForm"].validate(async (valid) => {
					if (valid) {
						var staff_ids = "";
						if(this.form.staff_ids.length > 0){
								this.form.staff_ids.forEach(item => {
								if (item != "" && item != null) {
									staff_ids += item + ',';
								}
							})
						}
						
						var url, record;
						if (this.condition.flag == 'group') {
							//修改集团
							url = "dictionaries/modify";
							record = {
								id: this.form.id,
								data: this.form.organize_name,
								spare5: staff_ids,
							};
						} else {
							url = "organize/update";
							record = {
								id: this.form.id,
								organize_name: this.form.organize_name,
								staff_ids: staff_ids,
								merge_id: this.form.merge_id.length > 0 ? this.form.merge_id[this.form
									.merge_id.length - 1] : "",
								organize_id:this.form.organize_id.length > 0 ? this.form.organize_id[this.form
									.organize_id.length - 1] : "",
								spare5: this.form.spare5,
								radio: this.form.radio,
								years_date: this.form.years_date,
							};
						}

						var data = await this.$globals.AxiosPost(url, record);
						if (data === '-2000') {
							this.$message.error('服务器未响应！请稍后重试');
						} else {
							var code = data.code;
							var data = data.data;
							if (code === '200') {
								this.$message.success(data);
								this.dialogVisible = false;
								
								this.structureFind();

							} else {
								this.$message.warning(data);
							}
						}

						// this.trash();

					} else {
						console.log('error submit!!');
						return false;
					}
				})
			},
			//清空
			// trash() {
			// 	this.form = {
			// 		id: "",
			// 		organize_name: "",
			// 		staff_ids: [],
			// 		staff_name: "",
			// 		merge_id: [],
			// 		merge_name: "",
			// 		organize_id:[],
			// 		spare5:"",
			// 	}
				
			// },
			//刷新结构页面
			structureFind() {
				this.$refs["Structure"].partialRefreshpartialRefresh();
			},
		},
		watch: {
			"condition.project_name": {
				handler(newVal, oldVal) {
					this.$refs["department"].from.organize_id = this.condition.project_id;
					this.$refs["department"].from.organize_name = this.condition.project_name;
				}
			}
		},
		mounted() {
			this.Find();
		}
	}
</script>

<style scoped="scoped">
	>>>.el-tabs__item.is-active {
		color: #006E4B;
	}

	>>>.el-tabs__active-bar {
		background-color: #006E4B;
	}

	>>>.el-tabs__item {
		font-size: 17px;
	}

	>>>.el-tabs__item:hover {
		color: #006E4B;
	}

	>>>.el-tabs__nav {
		margin-left: 60px;
	}

	>>>.el-tree-node.is-expanded>.el-tree-node__children {
		display: inline;
	}
</style>



// WEBPACK FOOTER //
// Jtzzjggl.vue?0c1af560